import {AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {JBMSelectOption} from '../JBMSelect/JBMSelect.component';

@Component({
  selector: 'jbm-multi-select',
  templateUrl: './JBMMultiSelect.component.html',
  styleUrls: ['./JBMMultiSelect.component.scss']
})
export class JBMMultiSelectComponent implements OnChanges {
  @Input() id: string='jbm-multi-select';
  @Input() options: JBMSelectOption[]=[];
  @Input() selection: number[]=[];
  @Input() minimumSelectionLength: number=0;
  @Input() removeableSelection: boolean=false;
  @Input() class: string='';
  @Input() editable: boolean=true;
  @Input() required: boolean=false;
  @Input() submitted: boolean=false;
  @Input() labelCaption: string='';
  @Input() labelClass: string='';
  @Input() labelStacked: boolean=false;
  @Input() dropUp: boolean=false;
  @Input() inputClass: string='';
  @Input() sm: boolean=false; // Condensed height
  @Input() disabled: boolean=false;

  @Output() onSelectionChange = new EventEmitter();
  @Output() onBlur = new EventEmitter();

  open: boolean=false;
  touched: boolean=false;

  constructor(private eRef: ElementRef) { }

  ngOnChanges(changes: SimpleChanges) {
    if(this.selection===undefined)
      this.selection=[];
    if(this.minimumSelectionLength<1)
      this.minimumSelectionLength=0;
    this.updateOptions()
  }
  toggle() {
    if(this.disabled) return;
    this.open=!this.open;
  }
  hide() {
    if(this.open) this.open=false;
  }
  toggleOption(index: number) {
    if(this.disabled) return;
    if(this.options[index].selected) {
      if(this.selection.length>this.minimumSelectionLength) {
        this.options[index].selected=false
        let selectedIndex=this.selection.indexOf(parseInt(this.options[index].key));
        this.selection.splice(selectedIndex, 1);
      }
    } else {
      this.options[index].selected=true
      this.selection.push(parseInt(this.options[index].key))
    }

    this.updateOptions()
    this.onSelectionChange.emit(this.selection);
  }
  updateOptions() {
    let disableSelection=this.minimumSelectionLength>0 && this.selection.length===this.minimumSelectionLength
    for(let option of this.options) {
      option.disabled=false
      option.selected=this.selection.indexOf(parseInt(option.key))>-1
      if(option.selected)
        option.disabled=disableSelection
    }
  }
  setSelection(event: any) {
    this.selection=event;
    this.onSelectionChange.emit(this.selection);
  }
  blur() {
    this.touched=true;
    this.onBlur.emit();
  }
  getOptionValue(selectedIndex: number) {
    let index=this.options.findIndex(function (option: any) { return parseInt(option.key)===selectedIndex} );
    return this.options[index].value
  }
  getSelected(key: string) {
    return this.selection.indexOf(parseInt(key))>-1
  }
  @HostListener("document:click", ['$event'])
  clickedOut(event: any) {
   if(!this.eRef.nativeElement.contains(event.target))
    this.hide();
  }
  @HostListener('document:keyup', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if(event.key=='Escape') this.hide();
  }

  protected readonly parseInt=parseInt;
}
